import http from "./httpService";
import { config } from "../config";
import { getIdentity } from "../components/common/commonFuncs";
////////////////////////////////////////////////////////////////
// TODO
const prefix = "/api/v2/dataSource/";

const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

export function getDataSources() {
  return http.get(apiEndpoint + prefix + "getSources", { params: { Activity_By: getIdentity() } });
}

export function getSourceTypes() {
  return http.get(apiEndpoint + prefix + "getSourceTypes", { params: {Activity_By: getIdentity()}});
}

export function getDatabaseTypes() {
  return http.get(apiEndpoint + prefix + "getDbTypes", { params: { Activity_By: getIdentity() } });
}

export function saveSourceDB(state) {
  return http.post(apiEndpoint + prefix + "saveDB", {
    DataSource_ID: state.DataSource_ID,
    DataSource_Type_ID: state.DataSource_Type_ID,
    Database_Type_ID: state.Database_Type_ID,
    Connection_String: state.Connection_String,
    Description: state.Description,
    Activity_By: getIdentity()
  });
}

export function testConn(conn) {
  return http.post(apiEndpoint + prefix + "testConnection", {
    Connection_String: conn,
    Activity_By: getIdentity()
  });
}

export function getSourceDB(dsid) {
  return http.get(apiEndpoint + prefix + "getSourceDB", {
    params: {
      DataSource_ID: dsid,
      Activity_By: getIdentity()
    },
  });
}

export function removeSource(id) {
  return http.post(apiEndpoint + prefix + "removeSource", {
    DataSource_ID: id,
    Activity_By: getIdentity()
  });
}

export function saveCustomDS(customAPI, mode, state){
  return http.post(apiEndpoint + customAPI, {
    id: state.ID,
    name: state.Name,
    mode: mode,
    DataSource_ID: state.DataSource_ID,
    ResultSource_ID: state.ResultSource_ID,
    ResultSource_Content: state.ResultSource_Content,
    Parameters: state.Parameters,
    Activity_By: getIdentity()
  });
}